import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { getUserInfo } from 'src/app/auth/adapters/knap'
import {
  evaluateHanwhaAccess,
  type IEvaluateHanwhaAccessReturn,
} from 'src/app/auth/domain/use-cases/evaluate-hanwha-access'
import { authKeys } from 'src/app/auth/queries/keys'

export interface IUseHanwhaAccessQueryParams {
  uuid: string | null
  enabled: boolean
}

export const useHanwhaAccessQuery = (
  params: IUseHanwhaAccessQueryParams,
): UseQueryResult<IEvaluateHanwhaAccessReturn, Error> => {
  const uuid = params.uuid
  return useQuery({
    queryKey: authKeys.hanwhaAccess(uuid ?? ''),
    queryFn: async () => {
      if (uuid === null) {
        // Fail-closed: a missing uuid means we cannot verify membership.
        return { allowed: false, isAdmin: false }
      }
      const probe = await getUserInfo({ uuid })
      return evaluateHanwhaAccess({ probe })
    },
    enabled: params.enabled,
    retry: false,
    staleTime: Infinity,
    meta: { silent: true },
  })
}
